import { useCatalogContext } from '../../../../state/Catalog';
import { useCatalogRegistryTranslations } from '../../../../Catalog.i18n';
import { useEffect } from 'react';
import { useGetPdpDataByProductIdQuery } from '@apps/registry/common/components/Catalog/api/queries/getPdpDataByProductId';
import { useCatalogRegistryTelemetry } from '@apps/registry/common/components/Catalog/Catalog.telemetry';

export const useQuickAddForm = ({ catalogItemId }: { catalogItemId: Maybe<string> }) => {
  const { catalogProductDetailsQueryError } = useCatalogRegistryTelemetry();
  const { getAddProductTranslations } = useCatalogRegistryTranslations();
  const { notificationText } = getAddProductTranslations();
  const { addCatalogItemToRegistry, addCatalogItemLoading, notificationVisible, setNotificationVisible } = useCatalogContext();

  const { product, error } = useGetPdpDataByProductIdQuery({
    catalogItemId,
    options: { batchMode: 'fast', variables: { withPdpSections: false, id: catalogItemId!, withProductRating: false } }
  });

  useEffect(() => {
    if (error && catalogItemId) {
      catalogProductDetailsQueryError({ catalogItemId, error });
    }
  }, [catalogProductDetailsQueryError, catalogItemId, error]);

  return {
    addCatalogItemToRegistry,
    addCatalogItemLoading,
    hasError: !!error,
    notificationText,
    notificationVisible,
    product: product || null,
    setNotificationVisible
  };
};
